export default __webpack_public_path__ + "static/media/CV KALIL BELGOUMRI.75404407.pdf";